<div class="center-loading-spinner" style="min-height: 70vh">
    <loading-component></loading-component>
</div>